import { ImageData } from '../optimized-image/optimized-image';

export enum Status {
  Active = 'active',
  Selected = 'selected',
  Disabled = 'disabled',
}

export interface IMoveIconProps {
  clickHandler: () => void;
  imgSrc: ImageData;
  imgSrcNotActive?: ImageData;
  text: string;
  status: Status;
  tabIndex?: number;
  disabled?: boolean;
}
